import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import SnoozeIcon from "@mui/icons-material/Snooze";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { useEffect, useRef, useState, useContext } from "react";
import ConfirmationDialog from "../../common/ConfirmationDialog";
import { AdminPreferencesService } from "../../services/adminPref.Service";
import { BallotDashboardService } from "../../services/ballotDashboard.Service";
import "./TeamBallotDashboard.css";
import { AppDataContext } from "../../common/appContext";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList as List } from "react-window";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import CloseIcon from "@mui/icons-material/Close";
import { handleUnauthorisedError } from "../../helper";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import EmptyUI from "../../sharedComponents/emptyStateUIContainers/EmptyUI";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import HomeIcon from "@mui/icons-material/Home";
import Loader from "../../sharedComponents/loader/loader";
import AppConstatnts from "../../common/AppConstants";

let gridData = [];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "auto",
    margin: "15px 15px 0px 15px",
    border: "1px solid lightgrey",
    boxShadow: "2px 2px 11px grey inset",
  },
  gridContainer: {
    margin: "15px",
    border: "1px solid lightgrey",
    borderRadius: "none",
    padding: theme.spacing(2),
  },
  gridTitle: {
    color: "#1d428a",
  },
  buttonArea: {
    "& button + button": {
      marginLeft: theme.spacing(2),
    },
  },
  shootingPoints: {
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(0, 0, 0, 3),
    },
    [theme.breakpoints.up("lg")]: {
      padding: theme.spacing(0, 0, 0, 4),
    },
  },
  borderRight: {
    position: "relative",
    paddingRight: theme.spacing(2.5),
    "&:after": {
      borderRight: "1px solid rgb(98, 122, 170)",
      content: '""',
      position: "absolute",
      right: "20px",
      width: "2px",
      height: "100%",
      top: "0",
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: "0px",
      "&:after": {
        borderRight: "none",
      },
    },
  },
  actionButton: {
    textTransform: "none",
    [theme.breakpoints.up("xs")]: {
      marginTop: "10px",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "0px",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "0px",
    },
    [theme.breakpoints.up("lg")]: {
      marginTop: "0px",
    },
    [theme.breakpoints.up("xl")]: {
      marginTop: "0px",
    },
  },
  statBoardHeaderTitle: {
    color: "#1d428a",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      fontWeight: "500",
      color: "#1d428a",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "2.5rem",
      fontWeight: "500",
      color: "#1d428a",
    },
  },
  totalVotesHeaderTitle: {
    color: "#1d428a",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8rem",
      fontWeight: "500",
      color: "#1d428a",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "2.5rem",
      fontWeight: "500",
      color: "#1d428a",
    },
  },
  positionsHeaderTitle: {
    color: "rgb(98,122,170)",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8rem",
      fontWeight: "500",
      color: "rgb(98,122,170)",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "2.3rem",
      fontWeight: "500",
      color: "rgb(98,122,170)",
    },
  },
  confirmationBallotRefreshDialog: {
    backgroundColor: "#1d428a",
    color: "#fff",
  },
  loadingOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default function GLeagueBallot() {
  const classes = useStyles();
  const totalVotes = useRef(0);
  const timer = useRef(0);
  const startDateTime = useRef(null);
  const endDateTime = useRef(null);
  const isSubmitted = useRef(true);
  const [playerNameSearchText, setPlayerNameSearchText] = useState("");
  const [playerData, setPlayerData] = useState([]);
  const [totalVotesSelected, setTotalVotesSelected] = useState(0);
  const [totalVotesSubmitted, setTotalVotesSubmitted] = useState(0);
  const [positionStats, setPositionStats] = useState([0, 0, 0, 0, 0]);
  const [open, setConfirmationBoxOpen] = useState(false);
  const [voteSort, setVoteSort] = useState(0);
  const [votingDisabled, setVotingDisabled] = useState(true);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [voteMessage, setVoteMessage] = useState("");
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState("warning");
  const [alertMessage, setAlertMessage] = useState("");
  const { user, loadContext } = useContext(AppDataContext);
  const [loading, setLoading] = useState(false);
  // const [windowInnerWidth, setWindowInnerWidth] = useState("auto")
  const [columnMaxWidth, setColumnMaxWidth] = useState(["none", "none"]);

  const [confirmFinalVotedPlayers, setConfirmFinalVotedPlayers] = useState([]);

  //Auto audit for ballot vote data holders.
  const [autoSaveFlag, setAutoSaveFlag] = useState(false);
  const currentVoteId = useRef(null);
  const [undoVote, setUndoVote] = useState(false);

  //Dialog Box data holders
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMsg, setDialogMsg] = useState(
    "A team member has updated the green room ballot. Click on yes to see the updated submissions."
  );

  //Api loading data holders
  const [disablePreVoting, setDisablePreVoting] = useState(false);

  const [ballotVoteEventId, setBallotVoteEventId] = useState(0);
  const [isTeamBallotVoteEnabled, setIsTeamBallotVoteEnabled] = useState("");

  //... Route
  const navigate = useNavigate();

  useEffect(() => {
    if (user.teamID && user.teamID > 0) {
      setLoading(true);
      try {
        //....#API-1 TO CHECK ENABLED BALLOT VOTE EVENTS.
        AdminPreferencesService.getCurrentEnabledBallotVoteEventDetails().then(
          async (response) => {
            //... Currrent Enabled Ballot Vote event reponse handling.
            const filteredObject =
              response?.data?.find(
                (obj) =>
                  obj.leagueId ===
                  AppConstatnts.BALLOT_VOTE
                    .NBA_DRAFTCOMBINE_TOP_FIVE_BALLOT_VOTE_EVENT_ID
              ) || {};

            if (Object.keys(filteredObject).length === 0) {
              setIsTeamBallotVoteEnabled(false);
              return;
            }

            setBallotVoteEventId(filteredObject.eventId);

            totalVotes.current = Object.keys(filteredObject).length
              ? filteredObject.maxVoteCount
              : 0;
            if (Object.keys(filteredObject).length && filteredObject.isActive) {
              startDateTime.current = moment(
                filteredObject.votingStartDatetime
              );
              endDateTime.current = moment(filteredObject.votingEndDatetime);

              timer.current = setInterval(() => {
                if (
                  startDateTime.current.isAfter(
                    moment(convertTZ(new Date(), "America/New_York"))
                  )
                ) {
                  setVotingDisabled(true);
                  setVoteMessage(
                    `Voting starts ${startDateTime.current.format(
                      "MM/DD/YYYY h:mm:ss a"
                    )} onwards`
                  );
                } else if (
                  startDateTime.current.isSameOrBefore(
                    moment(convertTZ(new Date(), "America/New_York"))
                  ) &&
                  endDateTime.current.isSameOrAfter(
                    moment(convertTZ(new Date(), "America/New_York"))
                  )
                ) {
                  let milliSeconds = endDateTime.current.diff(
                    moment(convertTZ(new Date(), "America/New_York"))
                  );
                  let seconds = Math.floor(milliSeconds / 1000);
                  let minutes = Math.floor(seconds / 60);
                  let hours = Math.floor(minutes / 60);
                  let days = Math.floor(hours / 24);
                  hours = hours - days * 24;
                  minutes = minutes - days * 24 * 60 - hours * 60;
                  // console.log(`${days} days ${hours} hours ${minutes} mins`);
                  if (isSubmitted.current) {
                    setVotingDisabled(true);
                  } else {
                    setVotingDisabled(false);
                  }
                  setDays(days);
                  setHours(hours);
                  setMinutes(minutes);
                } else {
                  setVotingDisabled(true);
                  setVoteMessage(
                    `Voting ended on ${endDateTime.current.format(
                      "MM/DD/YYYY h:mm:ss a"
                    )}`
                  );
                  clearInterval(timer.current);
                }
              }, 1000);
            } else {
              setVotingDisabled(true);
              setVoteMessage("No Active Ballot Vote");
            }

            //....#API-2 TO GET BALLOT VOTE PLAYERLIST FOR ENABLED BALLOT VOTE EVENT.
            try {
              const playerList =
                await BallotDashboardService.getBallotVotePlayersList(
                  user.teamID,
                  filteredObject.eventId
                );
              //console.log("playerList", playerList);

              //... Currrent Enabled Ballot Vote event player-list reponse handling.
              let players = playerList.data;
              isSubmitted.current = false;
              players.forEach((item) => {
                item.positionStats = [0, 0, 0, 0, 0];
                item.isPlayerVoted = item.isVoted;
                item.isAlreadyVoted = item.isVoted;
                item.playerPositionID = item.positionID;
                if (item.isVoted && item.positionID > 0) {
                  item.positionStats[item.positionID - 1] = 1;
                }
                if (item.isSubmitted) {
                  isSubmitted.current = true;
                }
              });
              gridData = [...players];
              setPlayerData(players);
              if (isSubmitted.current && votingDisabled) {
                setVotingDisabled(true);
                setVoteMessage("Ballot Vote submitted");
              } else if (
                isSubmitted.current === false &&
                votingDisabled === false
              ) {
                setVotingDisabled(false);
              }
              let currentTotalVotes = 0;
              players.forEach((elem) => {
                if (elem.isVoted) {
                  currentTotalVotes += 1;
                }
              });
              let currentSubmittedVotes = 0;
              players.forEach((elem) => {
                if (elem.isSubmitted) {
                  currentSubmittedVotes += 1;
                }
              });
              setTotalVotesSelected(currentTotalVotes);
              setTotalVotesSubmitted(currentSubmittedVotes);
              setPositionStats(() => {
                let totalSum = [0, 0, 0, 0, 0];
                players.forEach((elem) => {
                  elem.positionStats.forEach((row, i) => {
                    totalSum[i] = totalSum[i] + row;
                  });
                });
                return totalSum;
              });
              setIsTeamBallotVoteEnabled(true);
            } catch (error) {
              console.error("Error getting ballot vote players list:", error);
            }
          }
        );
      } catch (error) {
        console.error(
          "Error fetching current enabled ballot vote event details:",
          error
        );
      } finally {
        setLoading(false);
      }

      window.addEventListener("resize", onResize);

      return () => {
        clearInterval(timer.current);
        window.removeEventListener("resize", onResize);
      };
    } else {
      if (Object.keys(user).length === 0) loadContext();
    }
  }, [user]);

  useEffect(() => {
    if (autoSaveFlag) {
      if (totalVotesSelected > totalVotes.current) {
        //Undo current voted player details in case of current votes more than total expected votes.
        //setLoading(false);
        setAlert(true);
        setAlertType("warning");
        setAlertMessage(
          "Total votes selected should not exceed max vote count"
        );
        undoPlayerVote();
      } else {
        autoSaveDraftVotes();
      }
    }
  }, [autoSaveFlag, totalVotesSelected]);

  const onResize = () => {
    // setWindowInnerWidth(window.innerWidth <= 1300 ? 1460 : "auto");
    setColumnMaxWidth(
      window.innerWidth <= 600 ? ["180px", "80px"] : ["none", "none"]
    );
  };

  const padStart = (number) => (number > 9 ? number : `0${number}`);

  const handleAlertClose = (e) => {
    setAlert(false);
  };

  const handleConfirmationBoxClose = () => {
    setConfirmationBoxOpen(false);
    setConfirmFinalVotedPlayers([]);
  };

  const searchPlayer = (searchValue) => {
    setPlayerNameSearchText(searchValue);
    const updatedPlayerData = searchValue
      ? gridData.filter((elem) =>
          elem.playerName
            .toLowerCase()
            .includes(searchValue.toLowerCase().trim())
        )
      : gridData;
    setPlayerData(updatedPlayerData);
  };

  const votePlayer = async (e, index) => {
    try {
      const targetValue = e.target.checked;

      const payload = preparePayload();

      //Verify is any team member updated the voting list if yes auto refresh the page to get updated list else continue with old procedure.
      //setLoading(true);
      const isVerified = await verifyTeamVotingList(payload);
      // console.log("checked", targetValue);
      // console.log("isVerified", isVerified);
      // console.log("isVerified type", typeof isVerified);

      if (isVerified === true) {
        const updatedPlayerData = [...playerData];

        updatedPlayerData.forEach((elem, i) => {
          if (i === index) {
            elem.isVoted = targetValue;
            setTotalVotesSelected(totalVotesSelected + 1);
            if (elem.isVoted === false) {
              setTotalVotesSelected(totalVotesSelected - 1);
              if (elem.positionID) {
                setTotalVotesSubmitted(totalVotesSubmitted - 1);
                elem.positionID = 0;
                elem.isAlreadyVoted = elem.isVoted;
                elem.positionStats = [0, 0, 0, 0, 0];
              }
            }
          }
        });
        setPlayerData(updatedPlayerData);
        setPositionStats(() => {
          let totalSum = [0, 0, 0, 0, 0];
          gridData.forEach((elem) => {
            elem.positionStats.forEach((row, i) => {
              totalSum[i] = totalSum[i] + row;
            });
          });
          return totalSum;
        });

        //Set flag to know that votes list has been changed and need to save the votes into audit.
        currentVoteId.current = index;
        setAutoSaveFlag(true);
      } else {
        // setLoading(false);
        setOpenDialog(true);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const verifyTeamVotingList = async (obj) => {
    try {
      const { data } = await BallotDashboardService.verifyTeamVotingList(obj);
      return data;
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const preparePayload = () => {
    // const playerIDs = playerData
    //   .filter((player) => player.isVoted)
    //   .map((player) => player.playerID)
    //   .toString();

    const playerIDs = gridData
      .filter((player) => player.isVoted)
      .map((player) => player.playerID)
      .toString();

    return {
      eventId: ballotVoteEventId.toString(),
      teamId: user.teamID,
      playerIds: playerIDs,
    };
  };

  const toggleVoteSort = (sortOrder) => {
    setVoteSort(sortOrder);
    gridData.sort((x, y) => {
      if (sortOrder) {
        // true values first
        return x.isVoted === y.isVoted ? 0 : x.isVoted ? -1 : 1;
      } else {
        // false values first
        return x.isVoted === y.isVoted ? 0 : x.isVoted ? 1 : -1;
      }
    });
    setPlayerNameSearchText("");
    setPlayerData(gridData);
  };

  const validatePlayersList = () => {
    return gridData.filter((elem) => elem.isVoted).length ? true : false;
  };

  const handleSubmitAction = async (action = null) => {
    if (totalVotesSelected > totalVotes.current) {
      setConfirmationBoxOpen(false);
      setAlert(true);
      setAlertType("warning");
      setAlertMessage("Total votes submitted should not exceed max vote count");
    } else {
      try {
        const payload = preparePayload();
        const isVerified = await verifyTeamVotingList(payload);

        if (!isVerified) {
          setOpenDialog(true);
          return;
        }

        const isDataValid = validatePlayersList();
        if (isDataValid) {
          if (action === "final") {
            const tempData = [...gridData];
            const finalVotedPlayers = tempData.filter((elem) => elem.isVoted);
            setConfirmFinalVotedPlayers(finalVotedPlayers);
            setConfirmationBoxOpen(true);
          } else if (action === "draft") {
            submitBallotVoteList("draft");
          }
        } else if (action === "draft") {
          submitBallotVoteList("draft");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const submitBallotVoteList = (action) => {
    /* So this code is now added to resolve the above issue so that all the inital and new voted players and their positions will be considered during final submit */
    let finalFormData = gridData.filter((elem) => elem.isVoted);
    finalFormData.forEach((elem) => {
      elem.userBy = user.loginID;
      elem.modifiedByName = `${user.lastName}, ${user.firstName}`;
    });
    if (action === "draft") {
      //console.log(finalFormData);
      if (finalFormData.length === 0) {
        finalFormData = [
          {
            playerID: 0,
            teamID: user.teamID, //user.userTeamLeague[0].statsTeamID,
            EventId: `${ballotVoteEventId}`,
            isVoted: false,
            positionID: 0,
            isSubmitted: false,
            userBy: user.loginID,
            modifiedByName: `${user.lastName}, ${user.firstName}`,
          },
        ];
      }
      BallotDashboardService.insertBallotVotePlayersList(finalFormData).then(
        (response) => {
          setConfirmationBoxOpen(false);
          setAlert(true);
          setAlertType("success");
          setAlertMessage("Ballot Vote updated successfully");
        }
      );
    } else if (action === "final") {
      let formObj = [...finalFormData],
        valueSubmitted = 0;
      if (formObj.length) {
        formObj.forEach((elem) => {
          elem.isSubmitted = true;
          valueSubmitted += 1;
        });
      } else {
        formObj = [
          {
            playerID: 0,
            EventId: `${ballotVoteEventId}`,
            teamID: user.teamID, //user.userTeamLeague[0].statsTeamID,
            isSubmitted: true,
            userBy: user.loginID,
          },
        ];
      }
      BallotDashboardService.insertBallotVotePlayersList(formObj).then(
        (response) => {
          setConfirmationBoxOpen(false);
          if (response.data) {
            // true or false
            setTotalVotesSubmitted(valueSubmitted);
            setAlert(true);
            setAlertType("success");
            setAlertMessage("Ballot Vote submitted successfully");
            setVoteMessage("Ballot Vote submitted");
            isSubmitted.current = true;
            setVotingDisabled(true);
            BallotDashboardService.submitBallotVoteConfirmationEmailToTeamUser(
              ballotVoteEventId,
              user.teamID //user.userTeamLeague[0].statsTeamID
            ).then((result) => {});
          } else {
            setAlert(true);
            setAlertType("warning");
            setAlertMessage(
              "Total votes not equal to max count. Please review your votes before submitting."
            );
          }
        }
      );
    }
  };

  const Row = ({ index, style }) => (
    <Box
      className={`${index % 2 ? "ListItemOdd" : "ListItemEven"}`}
      style={style}
      sx={{
        display: "flex",
        // gridTemplateColumns: "300px 400px 200px 400px",
      }}
    >
      <Box sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `1 0 180px` }}>
        <Tooltip
          title={playerData[index].playerName}
          placement="bottom-start"
          enterTouchDelay={0}
        >
          <Typography
            noWrap
            component="p"
            variant={window.innerWidth < 769 ? "caption" : "body1"}
            pl={3}
            sx={{ paddingTop: "13px", fontWeight: "500" }}
          >
            {playerData[index].playerName}
          </Typography>
        </Tooltip>
      </Box>

      <Box sx={{ maxWidth: `${columnMaxWidth[1]}`, flex: `1 0 80px` }}>
        <Checkbox
          sx={{ marginTop: "4px" }}
          key={index}
          color="success"
          disabled={votingDisabled || disablePreVoting}
          checked={playerData[index].isVoted}
          onChange={(e) => votePlayer(e, index)}
          inputProps={{ "aria-label": "controlled" }}
        />
      </Box>
    </Box>
  );

  const VotedPlayersFinalConfirmationRow = ({ index, style }) => (
    <Box
      className={`${index % 2 ? "ListItemOdd" : "ListItemEven"}`}
      style={style}
      sx={{
        display: "flex",
      }}
    >
      <Box>
        <Tooltip
          title={confirmFinalVotedPlayers[index].playerName}
          placement="bottom-start"
          enterTouchDelay={0}
        >
          <Typography
            noWrap
            component="p"
            variant={window.innerWidth < 769 ? "caption" : "body1"}
            pl={3}
            sx={{ paddingTop: "13px", fontWeight: "500" }}
          >
            {confirmFinalVotedPlayers[index].playerName}
          </Typography>
        </Tooltip>
      </Box>
    </Box>
  );

  //Function will undo player vote.
  const undoPlayerVote = () => {
    const updatedPlayerData = [...playerData];
    updatedPlayerData.forEach((elem, i) => {
      if (i === currentVoteId.current) {
        elem.isVoted = false;
        elem.positionID = 0;
        elem.isAlreadyVoted = elem.isVoted;
        elem.positionStats = [0, 0, 0, 0, 0];

        setTotalVotesSelected((prev) => prev - 1);
      }
    });

    //setTotalVotesSelected((prev) => prev - 1);
    setPlayerData(updatedPlayerData);
    clearRef();
  };

  //Function will auto save the ballot votes list.
  const autoSaveDraftVotes = async () => {
    setDisablePreVoting(true);
    // setLoading(true);

    const finalFormData = gridData.filter(
      (elem, i) => elem.isVoted || i === currentVoteId.current
    );

    finalFormData.forEach((elem) => {
      elem.userBy = user.loginID;
      elem.modifiedByName = `${user.lastName}, ${user.firstName}`;
    });

    if (finalFormData.length > 0) {
      try {
        await BallotDashboardService.insertBallotVotePlayersList(finalFormData);
        clearRef();
        console.log("Auto Ballot Vote updated successfully");
      } catch (error) {
        handleUnauthorisedError(error);
      } finally {
        setDisablePreVoting(false);
        //setLoading(false);
      }
    }
  };

  const clearRef = () => {
    setAutoSaveFlag(false);
    currentVoteId.current = null;
  };

  function convertTZ(date, tzString) {
    return new Date(
      (typeof date === "string" ? new Date(date) : date).toLocaleString(
        "en-US",
        { timeZone: tzString }
      )
    );
  }

  const handleDialogAgree = () => {
    setOpenDialog(false);
    getPlayerVoteList();
  };

  const handleNavigateToHome = () => {
    navigate(RouteConstants.HOME);
  };

  const getPlayerVoteList = () => {
    setLoading(true);
    BallotDashboardService.getBallotVotePlayersList(
      user.teamID,
      ballotVoteEventId
    ).then((playerList) => {
      let players = playerList.data;
      isSubmitted.current = false;
      players.forEach((item) => {
        item.positionStats = [0, 0, 0, 0, 0];
        item.isPlayerVoted = item.isVoted;
        item.isAlreadyVoted = item.isVoted;
        item.playerPositionID = item.positionID;
        if (item.isVoted && item.positionID > 0) {
          item.positionStats[item.positionID - 1] = 1;
        }
        if (item.isSubmitted) {
          isSubmitted.current = true;
        }
      });
      gridData = [...players];
      setPlayerData(players);
      setLoading(false);
      if (isSubmitted.current && votingDisabled) {
        setVotingDisabled(true);
        setVoteMessage("Ballot Vote submitted");
      } else if (isSubmitted.current === false && votingDisabled === false) {
        setVotingDisabled(false);
      }
      let currentTotalVotes = 0;
      players.forEach((elem) => {
        if (elem.isVoted) {
          currentTotalVotes += 1;
        }
      });
      let currentSubmittedVotes = 0;
      players.forEach((elem) => {
        if (elem.isSubmitted) {
          currentSubmittedVotes += 1;
        }
      });
      setTotalVotesSelected(currentTotalVotes);
      setTotalVotesSubmitted(currentSubmittedVotes);
      setPositionStats(() => {
        let totalSum = [0, 0, 0, 0, 0];
        players.forEach((elem) => {
          elem.positionStats.forEach((row, i) => {
            totalSum[i] = totalSum[i] + row;
          });
        });
        return totalSum;
      });
      AdminPreferencesService.getCurrentEnabledBallotVoteEventDetails().then(
        (response) => {
          const filteredObject =
            response?.data?.find(
              (obj) =>
                obj.leagueId ===
                AppConstatnts.BALLOT_VOTE
                  .NBA_DRAFTCOMBINE_TOP_FIVE_BALLOT_VOTE_EVENT_ID
            ) || {};

          totalVotes.current = Object.keys(filteredObject).length
            ? filteredObject.maxVoteCount
            : 0;
          if (Object.keys(filteredObject).length && filteredObject.isActive) {
            startDateTime.current = moment(filteredObject.votingStartDatetime);
            endDateTime.current = moment(filteredObject.votingEndDatetime);

            timer.current = setInterval(() => {
              if (
                startDateTime.current.isAfter(
                  moment(convertTZ(new Date(), "America/New_York"))
                )
              ) {
                setVotingDisabled(true);
                setVoteMessage(
                  `Voting starts ${startDateTime.current.format(
                    "MM/DD/YYYY h:mm:ss a"
                  )} onwards`
                );
              } else if (
                startDateTime.current.isSameOrBefore(
                  moment(convertTZ(new Date(), "America/New_York"))
                ) &&
                endDateTime.current.isSameOrAfter(
                  moment(convertTZ(new Date(), "America/New_York"))
                )
              ) {
                let milliSeconds = endDateTime.current.diff(
                  moment(convertTZ(new Date(), "America/New_York"))
                );
                let seconds = Math.floor(milliSeconds / 1000);
                let minutes = Math.floor(seconds / 60);
                let hours = Math.floor(minutes / 60);
                let days = Math.floor(hours / 24);
                hours = hours - days * 24;
                minutes = minutes - days * 24 * 60 - hours * 60;
                // console.log(`${days} days ${hours} hours ${minutes} mins`);
                if (isSubmitted.current) {
                  setVotingDisabled(true);
                } else {
                  setVotingDisabled(false);
                }
                setDays(days);
                setHours(hours);
                setMinutes(minutes);
              } else {
                setVotingDisabled(true);
                setVoteMessage(
                  `Voting ended on ${endDateTime.current.format(
                    "MM/DD/YYYY h:mm:ss a"
                  )}`
                );
                clearInterval(timer.current);
              }
            }, 1000);
          } else {
            setVotingDisabled(true);
            setVoteMessage("No Active Ballot Vote");
          }
        }
      );
    });
  };

  return (
    <Container maxWidth="md">
      <Loader isLoading={loading} />

      {/* Page-content  */}
      {!isTeamBallotVoteEnabled && isTeamBallotVoteEnabled !== "" ? (
        <>
          <Grid container p={1}>
            <Grid item lg={12}>
              <EmptyUI
                heading="NBA Draft Top 5 Players Room Ballot"
                subHeading={
                  AppConstatnts.BALLOT_VOTE.BALLOT_VOTE_EVENT_HEADING_MSG
                }
                textColor="#000000"
                icon={<ContactSupportIcon />}
                iconStyles={{
                  fontSize: "10rem",
                  color: "#8c9dc4",
                }}
                styles={{
                  minHeight: "500px",
                }}
                actionLabel="Home"
                onActionClick={handleNavigateToHome}
                actionIcon={<HomeIcon />}
              />
            </Grid>
          </Grid>
        </>
      ) : isTeamBallotVoteEnabled ? (
        <>
          <Box>
            <Grid container p={1} className={classes.root}>
              <Grid
                item
                lg={5}
                md={5}
                sm={6}
                xs={12}
                className={classes.borderRight}
              >
                <Box pr={1.25}>
                  <Typography
                    component="div"
                    align="center"
                    className={`${classes.statBoardHeaderTitle} stat-board-header-title`}
                    // className="stat-board-header-title"
                  >
                    GLeague Ballot
                  </Typography>
                  <Typography
                    display="flex"
                    component="span"
                    justifyContent="center"
                    variant="subtitle2"
                    sx={{ color: "#c8102e" }}
                    className="timer"
                    // sx={{ color: "#D4485F" }}
                  >
                    <Box
                      columnGap={1}
                      display="flex"
                      component="span"
                      justifyContent="center"
                      sx={{ lineHeight: 1.8 }}
                    >
                      {votingDisabled ? (
                        voteMessage
                      ) : (
                        <>
                          <SnoozeIcon />
                          Time Remaining
                        </>
                      )}
                    </Box>
                  </Typography>
                  {votingDisabled ? (
                    ""
                  ) : (
                    <Typography
                      pl={2}
                      display="flex"
                      columnGap={1}
                      justifyContent="center"
                      component="div"
                      variant="subtitle2"
                      className="timer"
                    >
                      <div>
                        <span className="days">{padStart(days)}</span>
                        <div className="small-text">Days</div>
                      </div>
                      <div>
                        <span className="hours">{padStart(hours)}</span>
                        <div className="small-text">Hours</div>
                      </div>
                      <div>
                        <span className="minutes">{padStart(minutes)}</span>
                        <div className="small-text">Minutes</div>
                      </div>
                    </Typography>
                  )}
                </Box>
              </Grid>
              <Grid item lg={7} md={7} sm={6} xs={12}>
                <Grid container className={classes.shootingPoints}>
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <Typography
                      component="div"
                      className={`${classes.totalVotesHeaderTitle} ${
                        window.innerWidth <= 414
                          ? "total-votes-header-title-roboto"
                          : "total-votes-header-title-nba"
                      }`}
                    >
                      {`${padStart(totalVotesSelected)}/${padStart(
                        totalVotes.current
                      )}`}
                    </Typography>

                    {window.innerWidth <= 414 ? (
                      <Typography
                        align="left"
                        component="span"
                        variant={"caption"}
                        sx={{ color: "rgb(118, 118, 118)", fontSize: "0.7rem" }}
                      >
                        Total Votes Selected
                      </Typography>
                    ) : (
                      <Typography
                        align="left"
                        component="span"
                        variant={"subtitle2"}
                        sx={{ color: "rgb(118, 118, 118)" }}
                      >
                        Total Votes <br />
                        Selected
                      </Typography>
                    )}
                  </Grid>

                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <Typography
                      component="div"
                      className={`${classes.totalVotesHeaderTitle} ${
                        window.innerWidth <= 414
                          ? "total-votes-header-title-roboto"
                          : "total-votes-header-title-nba"
                      }`}
                      sx={{ color: "#c8102e !important" }}
                    >
                      {`${padStart(totalVotesSubmitted)}/${padStart(
                        totalVotes.current
                      )}`}
                    </Typography>
                    {window.innerWidth <= 414 ? (
                      <Typography
                        align="left"
                        component="span"
                        variant={"caption"}
                        sx={{ color: "rgb(118, 118, 118)", fontSize: "0.7rem" }}
                      >
                        Total Votes Submitted
                      </Typography>
                    ) : (
                      <Typography
                        align="left"
                        component="span"
                        variant={"subtitle2"}
                        sx={{ color: "rgb(118, 118, 118)" }}
                      >
                        Total Votes <br />
                        Submitted
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Alert severity="info" sx={{ margin: "15px 15px 0" }}>
              {window.innerWidth <= 414 ? (
                <Typography sx={{ fontSize: "0.7rem !important" }}>
                  Note: "Final Submit" enables after reaching max vote count
                  defined. Once complete, please review your votes and submit.
                </Typography>
              ) : (
                `Note: "Final Submit" enables after reaching max vote count defined.
            Once complete, please review your votes and submit.`
              )}
            </Alert>
            <Paper elevation={2} className={classes.gridContainer}>
              <Box>
                <Grid container>
                  <Grid item lg={5} md={6} sm={6} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        size="small"
                        label="Search Player"
                        value={playerNameSearchText || ""}
                        onChange={(e) => searchPlayer(e.target.value)}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {playerNameSearchText !== "" && (
                                <IconButton
                                  aria-label="Clear Search"
                                  onClick={(e) => searchPlayer("")}
                                  edge="end"
                                >
                                  <ClearIcon color="secondary" />
                                </IconButton>
                              )}
                              <IconButton aria-label="Search" edge="end">
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </FormControl>
                  </Grid>
                  {/* <Grid lg={3} md={1}></Grid> */}
                  <Grid
                    item
                    lg={7}
                    md={6}
                    sm={6}
                    xs={12}
                    container
                    justifyContent="flex-end"
                    className={classes.buttonArea}
                  >
                    <Button
                      className={classes.actionButton}
                      variant="contained"
                      onClick={() => handleSubmitAction("draft")}
                      disabled={votingDisabled}
                    >
                      Save as Draft
                    </Button>
                    <Button
                      className={classes.actionButton}
                      disabled={
                        votingDisabled ||
                        (totalVotesSelected === totalVotes.current
                          ? false
                          : true)
                      }
                      variant="contained"
                      onClick={() => {
                        handleSubmitAction("final");
                      }}
                    >
                      Final Submit
                    </Button>
                  </Grid>
                </Grid>
                <Snackbar
                  open={alert}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  autoHideDuration={3000}
                  onClose={handleAlertClose}
                >
                  <Alert
                    onClose={handleAlertClose}
                    severity={alertType}
                    sx={{ width: "100%" }}
                  >
                    {alertMessage}
                  </Alert>
                </Snackbar>
                <ConfirmationDialog
                  open={open}
                  dialogTitle={
                    "Please review your votes before final submission"
                  }
                  messageBody={
                    <Box
                      mt={2}
                      sx={{
                        // overflow: "auto",
                        // overflowY: "hidden",
                        height: "100%",
                        width: "100%",
                      }}
                      className="player-list-box"
                    >
                      <Box
                        className="row-header"
                        sx={{
                          display: "flex",
                          // gridTemplateColumns: "300px 400px 200px 400px",
                          width: "auto",
                        }}
                      >
                        <Box>
                          <Typography
                            noWrap
                            pl={3}
                            sx={{
                              paddingTop: "10px",
                              paddingBottom: "10px",
                              fontWeight: "500",
                            }}
                          >
                            Player
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          height: "400px",
                          width: "auto",
                        }}
                      >
                        <AutoSizer>
                          {({ height, width }) => (
                            <>
                              <List
                                height={height}
                                width={width}
                                itemSize={50}
                                itemCount={confirmFinalVotedPlayers.length}
                              >
                                {VotedPlayersFinalConfirmationRow}
                              </List>
                            </>
                          )}
                        </AutoSizer>
                      </Box>
                    </Box>
                  }
                  onClose={handleConfirmationBoxClose}
                  onSubmit={() => {
                    submitBallotVoteList("final");
                  }}
                  teamBallotDashboard={false}
                />
              </Box>
              <Box
                mt={2}
                sx={{
                  height: votingDisabled
                    ? "calc(100vh - 396px)"
                    : "calc(100vh - 444px)",
                  overflow: "auto",
                  overflowY: "hidden",
                }}
                className="player-list-box"
              >
                <Box
                  className="row-header"
                  sx={{
                    display: "flex",
                    // gridTemplateColumns: "300px 400px 200px 400px",
                    width: "auto",
                  }}
                >
                  <Box
                    sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `1 0 180px` }}
                  >
                    <Typography
                      noWrap
                      pl={3}
                      sx={{
                        paddingTop: "10px",
                        paddingBottom: "10px",
                        fontWeight: "500",
                      }}
                    >
                      Player
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      maxWidth: `${columnMaxWidth[1]}`,
                      flex: `1 0 80px`,
                      display: "flex",
                      flexDirection: "row",
                      columnGap: "5px",
                    }}
                  >
                    <Typography
                      sx={{
                        paddingTop: "10px",
                        paddingBottom: "10px",
                        fontWeight: "500",
                      }}
                    >
                      Vote
                    </Typography>
                    {voteSort ? (
                      <ArrowDropUpIcon
                        sx={{ marginTop: "10px", cursor: "pointer" }}
                        onClick={(e) => toggleVoteSort(0)}
                      />
                    ) : (
                      <ArrowDropDownIcon
                        sx={{ marginTop: "10px", cursor: "pointer" }}
                        onClick={(e) => toggleVoteSort(1)}
                      />
                    )}
                  </Box>
                </Box>
                <Box
                  sx={{
                    /*height: "calc(100vh - 475px)"*/ height: "100%",
                    width: "auto",
                  }}
                >
                  <AutoSizer>
                    {({ height, width }) => (
                      <>
                        <List
                          height={height}
                          width={width}
                          itemSize={50}
                          itemCount={playerData.length}
                        >
                          {Row}
                        </List>
                      </>
                    )}
                  </AutoSizer>
                </Box>
              </Box>
            </Paper>

            {/* Player Voting list refersh dialog box */}
            <Dialog
              open={openDialog}
              onClose={() => setOpenDialog(false)}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle className={classes.confirmationBallotRefreshDialog}>
                Confirmation
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <Typography variant="h6" color="#000">
                    {dialogMsg}
                  </Typography>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => setOpenDialog(false)}
                  variant="contained"
                  color="secondary"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleDialogAgree}
                  variant="contained"
                  color="primary"
                  autoFocus
                >
                  Yes
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </>
      ) : (
        <Box className={classes.loadingOverlay}>
          <CircularProgress />
        </Box>
      )}
    </Container>
  );
}
